<template>
    <div class="calendar-app">
        <div class="app-calendar-main">
            <div class="d-flex mt-4 justify-content-center" v-if="this.eventSlug.toLowerCase() == 'events'">
                <h6 class="fs-6 fw-medium ppv2-text-black pt-1">Tous les événements</h6>
                <div class="form-check form-switch me-4">
                    <input type="checkbox" v-model="showAll" class="form-control form-check-input" />
                </div>
            </div>
            <FullCalendar
                class="calendar-app-calendar"
                :options="calendarOptions"
                :plugins="calendarPlugins"
                :events="calendarEvents"
                @datesSet="handleDateChange"
                ref="fullCalendar"
            >
                <template v-slot:eventContent="arg">
                    <!-- <b>{{ arg.timeText }}</b> -->
                    <b v-html="arg.event.title"></b>
                </template>
            </FullCalendar>
        </div>

        <modal name="planning-modal" :width="700" :height="800" :adaptive="true">
            <ModalPlanningContent
                :countryVatRates="countryVatRates"
                :showModal="showModal"
                :prestationId="prestationId"
                :selectedSlot="selectedSlotData"
                :prestation="prestation"
                :preDataInit="preDataInit"
                :mode="mode"
                :canEditTime="canEditTime"
                @refreshCalendar="refreshCalendar"
                v-if="showModal"
            />
        </modal>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import frLocale from '@fullcalendar/core/locales/fr'
import EventModalContent from './EventModalContent.vue'
import ModalPlanningContent from './ModalPlanningContent.vue'
import axios from 'axios'
import ApiManager from '../Calendar/_core/ApiManager.js'

export default {
    props: {
        prestationId: {
            required: true,
        },
        establishmentId: {
            required: true,
        },
        eventSlug: {
            required: true,
        },
        countryVatRates: {
            required: true,
        },
    },

    components: {
        EventModalContent,
        ModalPlanningContent,
        FullCalendar, // make the <FullCalendar> tag available
    },

    data: function () {
        return {
            popupShow: false,

            isLoading: false,

            newEventTitle: '',
            calendarEvents: [],
            backUpCalendarEvents: [],

            showModal: false,
            selectedSlotData: {},

            startCalender: '',
            endCalender: '',

            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin, // needed for dateClick
                ],
                headerToolbar: {
                    left: 'today',
                    center: 'title',
                    right: 'prev,next',
                    // right: 'dayGridMonth,timeGridWeek,timeGridDay',
                },
                initialView: 'dayGridMonth',
                locale: frLocale,
                // events: {
                //     url: `/back-office/prestation/${this.prestationId}/planning/${this.establishmentId}/filter`,
                //     method: 'GET',
                //     success: this.handleEventsFromBackend,
                // },
                events: this.fetchEvents,
                // eventColor: '#000',
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                // select: this.handleDateSelect,
                dateClick: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                datesSet: this.handleDateChange,

                /* you can update a remote database when these fire:
                    eventAdd:
                    eventChange:
                    eventRemove:
                */
            },
            calendarPlugins: [dayGridPlugin],

            currentEvents: [],
            prestation: null,
            showAll: false,
            URLs: {},
            mode: 'create',
            preDataInit: {
                start: null,
                end: null,
                priceHT: null,
                tva: null,
            },
            canEditTime: true,
        }
    },

    methods: {
        showModalTest() {
            this.$modal.show('planning-modal')
            this.showModal = true
        },

        closeModal() {
            this.$modal.hide('planning-modal')
            this.showModal = false
        },
        async getPrestation() {
            try {
                const data = await ApiManager.getPrestationDetails(this.prestationId)
                this.prestation = data.prestation
                // console.log(' this.prestation', this.prestation)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //throw error; // Rethrow the error if needed
            }
        },
        async init() {
            try {
                await this.getPrestation()
                // Additional initialization logic can go here
                if (this.eventSlug.toLowerCase() == 'events') {
                    if (this.prestation.prestation_planning[0]) {
                        this.gotToDate(this.prestation.prestation_planning[0].start_date)
                        this.setPreDataInit(
                            this.prestation.prestation_planning[0].planning_prices[0].start_time,
                            this.prestation.prestation_planning[0].planning_prices[0].end_time,
                            this.prestation.prestation_planning[0].planning_prices[0].price_ht,
                            this.prestation.prestation_planning[0].planning_prices[0].vat_rate
                        )
                        this.refreshCalendar()
                    }

                    await this.setCanEditTime(this.prestation.id)
                } else {
                    this.setPreDataInit(null, null, this.prestation.price_ht, this.prestation.vat_rate)
                }

                // console.log('setPreDataInit', this.preDataInit)
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },
        setPreDataInit(start, end, priceHT, tva) {
            // console.log('setPreDataInit cahnged', start, end, priceHT, tva)
            this.preDataInit.start = start
            this.preDataInit.end = end
            this.preDataInit.priceHT = priceHT
            this.preDataInit.tva = tva
        },

        async setCanEditTime() {
            console.log('call setCanEditTime ')
            const data = await ApiManager.setCanEditTime(this.prestationId)

            this.canEditTime = data
        },

        handleEventsFromBackend(response) {
            // console.log('response', response)
            this.calendarEvents = response.map((event) => ({
                id: event.id,
                title: event,
                start: event.start,
                end: event.end,
            }))

            // console.log('calendarEvents', this.calendarEvents)
        },

        onEventSaved(newEventTitle) {
            this.newEventTitle = newEventTitle // Store the new event title
            //  console.log('New Event Title:', this.newEventTitle)
            // Perform any necessary action with the saved event title
            this.showModal = false // Close the modal after handling the event
        },

        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
        },

        handleDateSelect(selectInfo) {
            this.mode = 'create'
            this.startCalender = selectInfo.dateStr
            this.endCalender = selectInfo.dateStr

            this.showModalTest()

            // Access the selected slot's information
            const selectedSlot = {
                start: selectInfo.dateStr,
                end: selectInfo.dateStr,
                allDay: selectInfo.allDay,
                // Add more properties as needed to represent the slot data
            }

            this.selectedSlotData = selectedSlot // Update the data property
        },

        handleEventClick(clickInfo) {
            this.mode = 'edit'
            // console.log('handleEventClick', clickInfo.dateStr)
            if (clickInfo.event.extendedProps.prestationId == this.prestationId) {
                this.showModalTest()
                // this.showModal = true
                this.selectedSlotData = clickInfo.event // Update the data property
            }

            // if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
            //     clickInfo.event.remove()
            // }
        },

        handleEvents(events) {
            this.currentEvents = events
        },

        handleDateChange(info) {
            const start = info.startStr
            const end = info.endStr
            this.refreshCalendar()
        },
        fetchAllPrestationPlanning(start, end) {
            return axios.get(`/back-office/prestation/${this.prestationId}/planning/${this.establishmentId}/filter`, {
                params: {
                    start,
                    end,
                },
            })
        },
        fetchAllPrestationHasEventsSlug(start, end) {
            return axios.get(`/back-office/prestation/${this.prestation.subcategory_id}/planning/${this.establishmentId}/`, {
                params: {
                    start,
                    end,
                },
            })
        },
        async fetchEvents(fetchInfo, successCallback, failureCallback, refresh = false) {
            var start = (this.startCalender = fetchInfo?.startStr ?? this.startCalender)
            var end = (this.endCalender = fetchInfo?.endStr ?? this.endCalender)
            if (!this.prestation) {
                // console.log('run !this.prestation')
                await this.init()
            }
            try {
                // console.log('wait get Events ...')
                if (this.backUpCalendarEvents.length == 0) await this.getEvents(start, end)
                // console.log('after get Events', this.calendarEvents)
                if (typeof successCallback === 'function') {
                    // Pass the events to FullCalendar's successCallback
                    successCallback(this.calendarEvents)
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        refreshCalendar() {
            // console.log('refreshCalendar ..')
            this.calendarEvents = []
            this.backUpCalendarEvents = [] // Clear current events
            this.fetchEvents() // Fetch new events

            setTimeout(() => {
                const calendarRef = this.$refs.fullCalendar

                if (calendarRef) {
                    calendarRef.getApi().refetchEvents()
                }
            }, 100)
        },
        async getEvents(start, end) {
            this.isLoading = true

            try {
                let response =
                    this.eventSlug.toLowerCase() == 'events'
                        ? await this.fetchAllPrestationHasEventsSlug(start, end)
                        : await this.fetchAllPrestationPlanning(start, end)

                const events = response.data.map((event) => ({
                    id: event.id,
                    title: event.title,
                    start: event.start,
                    end: event.end,
                    prestationId: event.prestationId,
                    color: '#000',
                    backgroundColor: 'red',
                }))
                this.backUpCalendarEvents = response.data
                this.calendarEvents = this.showAll
                    ? this.backUpCalendarEvents
                    : this.backUpCalendarEvents.filter((el) => el.prestationId == this.prestationId)
                // console.log(' this.calendarEvents', this.calendarEvents)

                this.isLoading = false
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.isLoading = false
                // failureCallback(error)
                throw new Error('Error fetching events')
            }
        },
        /**
         *
         * @param {String} date
         * point the calendar view in a specific date.
         */
        gotToDate(date) {
            this.$refs.fullCalendar.getApi().gotoDate(date)
            setTimeout(() => {
                const calendarRef = this.$refs.fullCalendar
                if (calendarRef) {
                    calendarRef.getApi().refetchEvents()
                }
            }, 1000)
        },
    },

    async mounted() {
        await this.init()
    },
    beforeMount() {},
    watch: {
        showAll(newVal, oldVal) {
            this.calendarEvents = this.showAll
                ? this.backUpCalendarEvents
                : this.backUpCalendarEvents.filter((el) => el.prestationId == this.prestationId)

            this.$refs.fullCalendar.getApi().refetchEvents()
        },
        calendarEvents(newVal, oldVal) {
            //  if (!this.isLoading) this.$refs.fullCalendar.getApi().refetchEvents()
            //  console.log('calendarEvents changed ', newVal)
            //   this.backUpCalendarEvents = this.calendarEvents
        },
    },
}
</script>

<style scoped lang="css">
h2 {
    margin: 0;
    font-size: 16px;
}

ul {
    margin: 0;
    padding: 0 0 0 1.5em;
}

li {
    margin: 1.5em 0;
    padding: 0;
}

b {
    /* used for event dates/times */
    margin-right: 3px;
}

.calendar-app {
    display: flex;
    min-height: 100%;
    font-family:
        Arial,
        Helvetica Neue,
        Helvetica,
        sans-serif;
    font-size: clamp(12px, 0.729545vw, 16px);
}

.calendar-app-sidebar {
    width: 300px;
    line-height: 1.5;
    background: #eaf9ff;
    border-right: 1px solid #d3e2e8;
}

.calendar-app-sidebar-section {
    padding: 2em;
}

.app-calendar-main {
    flex-grow: 1;
    padding-top: 3em;
    padding-bottom: 3em;
}

.fc {
    /* the calendar root */
    max-width: 1100px;
    margin: 0 auto;
}

/* Default styles */
.modal {
    width: 60%; /* Or any default width */
}

/* Media query for smaller screens */
@media (max-width: 768px) {
    .modal {
        width: 90%; /* Adjust width for smaller screens */
    }
}
</style>
